/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Schema field
 * @export
 * @interface InternalApiCustomSchemaField
 */
export interface InternalApiCustomSchemaField {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomSchemaField
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomSchemaField
     */
    displayName?: string;
    /**
     * 
     * @type {InternalApiCustomSchemaFieldTypeEnum}
     * @memberof InternalApiCustomSchemaField
     */
    type: InternalApiCustomSchemaFieldTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiCustomSchemaField
     */
    options?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiCustomSchemaFieldTypeEnum {
    STRING = 'STRING',
    STRINGLIST = 'STRINGLIST'
}


/**
 * Check if a given object implements the InternalApiCustomSchemaField interface.
 */
export function instanceOfInternalApiCustomSchemaField(value: object): value is InternalApiCustomSchemaField {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function InternalApiCustomSchemaFieldFromJSON(json: any): InternalApiCustomSchemaField {
    return InternalApiCustomSchemaFieldFromJSONTyped(json, false);
}

export function InternalApiCustomSchemaFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomSchemaField {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'type': json['type'],
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function InternalApiCustomSchemaFieldToJSON(json: any): InternalApiCustomSchemaField {
    return InternalApiCustomSchemaFieldToJSONTyped(json, false);
}

export function InternalApiCustomSchemaFieldToJSONTyped(value?: InternalApiCustomSchemaField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'displayName': value['displayName'],
        'type': value['type'],
        'options': value['options'],
    };
}

